export class ResellerUpdateModel {
    url: string;
    zipCode: string;
    address: string;
    shop: string;
    email: string;
    resellerType: number;
    directoryId:number;
}